// extracted by mini-css-extract-plugin
export default {"formCard":"AddBookingOptionModal_formCard__gF6bW","summaryBox":"AddBookingOptionModal_summaryBox__tO2hg","summaryIcon":"AddBookingOptionModal_summaryIcon__repig"};